//
// Generated class PriceRule
//

/// <reference path="PriceRule_ManagedObject.ts" />

class PriceRule extends PriceRule_ManagedObject
{

}